"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var AppPaySystemWalletReceivesList = /** @class */ (function (_super) {
    __extends(AppPaySystemWalletReceivesList, _super);
    function AppPaySystemWalletReceivesList(props) {
        return _super.call(this, props) || this;
    }
    AppPaySystemWalletReceivesList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    AppPaySystemWalletReceivesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    AppPaySystemWalletReceivesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    AppPaySystemWalletReceivesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    AppPaySystemWalletReceivesList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadRangeData({
            inner_pay_wallet_id: this.props.root.key,
            Limit: this.state.pageSize,
            Offset: this.getDataOffset(),
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute')
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    AppPaySystemWalletReceivesList.prototype.getColumns = function () {
        var _this = this;
        return [{
                title: 'Дата',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 150
            }, {
                title: 'Сумма поступления',
                dataIndex: this.props.data.dk_amount,
                key: this.props.data.dk_amount,
                width: 150,
            }, {
                title: 'Из кошелька',
                dataIndex: this.props.data.dk_wallet_from,
                key: this.props.data.dk_wallet_from,
                width: 150,
            }, {
                title: 'В кошелек',
                dataIndex: this.props.data.dk_wallet_to,
                key: this.props.data.dk_wallet_to,
                width: 150,
            }, {
                title: 'Пул кошелька',
                dataIndex: this.props.data.dk_pool_tag,
                key: this.props.data.dk_pool_tag,
                width: 150
            }, {
                title: 'Транзакция в блокчейн',
                dataIndex: this.props.data.dk_blockchain_transaction,
                key: this.props.data.dk_blockchain_transaction,
                width: 150,
            }];
    };
    AppPaySystemWalletReceivesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    AppPaySystemWalletReceivesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    AppPaySystemWalletReceivesList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    AppPaySystemWalletReceivesList.prototype.getToolbarRenderObject = function () {
        return (React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
            React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) })));
    };
    AppPaySystemWalletReceivesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            this.getToolbarRenderObject(),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_blockchain.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return AppPaySystemWalletReceivesList;
}(React.Component));
exports.default = AppPaySystemWalletReceivesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_wallets/ui/component/AppPaySystemWalletReceivesList.tsx
// module id = 2567
// module chunks = 0